__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-26-1772095985-stable-dev/";